// extracted by mini-css-extract-plugin
export default {"wrap":"Ru-z","searchHeaderWrap":"Su-z","melodyCategory":"Tu-z","fullWidth":"Uu-z","items":"Vu-z","featureCss":"Wu-z","disabled":"Xu-z","imgCss":"Yu-z"};